// src/styles/theme.js
import { createTheme } from '@mui/material/styles';

export const THEME_COLORS = {
  primary: '#272361',
  secondary: '#6366F1',
  success: '#10B981',
  warning: '#F59E0B',
  error: '#EF4444',
  info: '#3B82F6'
};

const theme = createTheme({
  palette: {
    primary: {
      main: THEME_COLORS.primary,
    },
    secondary: {
      main: THEME_COLORS.secondary,
    },
    success: {
      main: THEME_COLORS.success,
    },
    warning: {
      main: THEME_COLORS.warning,
    },
    error: {
      main: THEME_COLORS.error,
    },
    info: {
      main: THEME_COLORS.info,
    },
  },
  typography: {
    fontFamily: [
      'Inter',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          fontWeight: 600,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          backgroundColor: THEME_COLORS.primary,
        },
      },
    },
  },
});

export default theme;